//@flow
import React, { Fragment } from 'react';

import Toggler from '../Toggler';

import { truncateText } from './utils';

type Props = {
  text: string,
  className: string,
};

const charLimit = 410;

const TextClampWithDots = ({ text, className }: Props) =>
  text.length <= charLimit ? (
    <p className={className}>{text}</p>
  ) : (
    <Toggler>
      {({ on, toggle }) => (
        <Fragment>
          <p className={className}>{on ? text : truncateText(text, charLimit)}</p>
          <span onClick={toggle} className="read-more-comment">
            {on ? 'See Less' : 'Read More'}
          </span>
        </Fragment>
      )}
    </Toggler>
  );

export default TextClampWithDots;
